<div class="page-layout">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Breadcrumb -->
    <nav class="breadcrumb">
      <a href="#" class="breadcrumb-item">
        <svg viewBox="0 0 24 24" class="breadcrumb-icon">
          <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
      </a>
      <span class="breadcrumb-separator">›</span>
      <a href="#" class="breadcrumb-item">Settings</a>
      <span class="breadcrumb-separator">›</span>
      <span class="breadcrumb-item active">Branches</span>
    </nav>

    <!-- Page Header -->
    <header class="page-header">
      <h1 class="page-title">Branches</h1>
      <button class="btn btn-primary">
        <svg viewBox="0 0 24 24" class="btn-icon">
          <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
        </svg>
        Add branch
      </button>
    </header>

    <!-- Content Card -->
    <div class="content-card">
      <!-- Table Header -->
      <div class="table-header">
        <div class="table-title-section">
          <h2 class="table-title">Branches list</h2>
          <span class="badge badge-blue">{{branches.length}}</span>
        </div>
        <div class="search-box">
          <svg viewBox="0 0 24 24" class="search-icon">
            <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
          <input
            type="text"
            placeholder="Search"
            class="search-input"
            [(ngModel)]="searchQuery"
            (input)="onSearch()"
          />
        </div>
      </div>

      <!-- Table -->
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>Branch Name</th>
              <th>City</th>
              <th>Address</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Created</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="7" style="text-align: center; padding: 2rem;">
                Loading branches...
              </td>
            </tr>
            <tr *ngIf="!isLoading && paginatedBranches.length === 0">
              <td colspan="7" style="text-align: center; padding: 2rem;">
                No branches found.
              </td>
            </tr>
            <tr *ngFor="let branch of paginatedBranches" class="table-row animate-fade-in">
              <td>
                <span class="specialty-text font-weight-600">{{branch.name}}</span>
              </td>
              <td>
                <span class="location-text">{{branch.city || 'N/A'}}</span>
              </td>
              <td>
                <span class="location-text">{{branch.address || 'N/A'}}</span>
              </td>
              <td>
                <span class="phone-text">{{branch.phoneNumber || 'N/A'}}</span>
              </td>
              <td>
                <span class="level-badge" [class.active]="branch.isActive">
                  {{branch.isActive ? 'Active' : 'Inactive'}}
                </span>
              </td>
              <td>
                <span class="date-text">{{branch.createdAt | date: 'MMM d, y'}}</span>
              </td>
              <td>
                <div class="action-buttons">
                  <button class="action-btn" title="Delete">
                    <svg viewBox="0 0 24 24">
                      <path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                    </svg>
                  </button>
                  <button class="action-btn" title="Edit">
                    <svg viewBox="0 0 24 24">
                      <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination">
        <button class="btn btn-secondary btn-sm" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <svg viewBox="0 0 24 24" class="btn-icon-sm">
            <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
          </svg>
          Previous
        </button>
        <div class="pagination-numbers">
          <button
            *ngFor="let page of visiblePages"
            class="page-btn"
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >
            {{page}}
          </button>
        </div>
        <button class="btn btn-secondary btn-sm" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
          Next
          <svg viewBox="0 0 24 24" class="btn-icon-sm">
            <path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </button>
      </div>
    </div>
  </main>
</div>
